import React, { useState } from 'react'
import SearchField from '../../../../shared/SearchField'
import CustomButton from '../../../../shared/CustomButton'
import CustomTable from '../../../../shared/CustomTable'
import { EyeIcon } from '../../../../utils/TableActionIcons'
import DropdownField from '../../../../shared/DropdownField'
import {
  dummyRedData,
  InventoryItemsData,
  ItemInventoryColumns
} from '../../../../constants/InverntoryConstants'
import { useNavigate } from 'react-router-dom'
import { FaBoxOpen } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

function StockList () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [payloadData, setPayloadData] = useState({
    start_date: null,
    end_date: null
  })

  const handleChange = (date, name) => {
    setPayloadData({ ...payloadData, [name]: date })
  }
  const [open, setOpen] = useState(false)
  const [selectedData, setSelectedData] = useState(null)

  const ActionTemepelate = rowData => {
    return (
      <div className='flex justify-start gap-2 items-center'>
        <EyeIcon />
        <FaBoxOpen
          size={17}
          className='text-primary cursor-pointer'
          title={t('ManageStock')}
          onClick={() => {
            navigate('/manage-stock')
          }}
        />
      </div>
    )
  }

  const action = {
    body: ActionTemepelate,
    header: t('Actions'),
    headerCellClass: '!bg-gray-200'
  }

  const columns = [action, ...ItemInventoryColumns(t)]

  return (
    <div>
      <div className='flex flex-wrap justify-between w-full gap-4 items-center'>
        <div className='w-full sm:w-auto'>
          <SearchField className='w-full sm:w-[300px]' placeholder='Search' />
        </div>

        <div className='flex flex-wrap justify-start w-full gap-3 items-start sm:w-auto'>
          <DropdownField
            placeholder={t('SelectSubcategory')}
            useFormik={false}
            options={[]}
            className='w-full sm:w-[200px]'
          />
          <DropdownField
            placeholder={t('Select')}
            useFormik={false}
            options={[]}
            className='w-full sm:w-[200px]'
          />

          <CustomButton
            label={t('ApplyFilters')}
            icon={'pi pi-filter'}
            className='h-[35px] w-full sm:w-fit'
          />
        </div>
      </div>
      <div className='mt-4'>
        <CustomTable columns={columns} data={InventoryItemsData} />
      </div>
    </div>
  )
}

export default StockList
